module.exports = __webpack_public_path__ + "static/media/3.baf7e04c.jpg";